import React from 'react';
import PropTypes from 'prop-types';
import DateTimePickerField from './DateTimePickerField';
import { useFormikContext } from 'formik';

const DateTimeRangePicker = ({ minStartDate, maxEndDate }) => {
  const { values } = useFormikContext();

  const disabledStartDate = new Date(minStartDate);
  const disabledEndDate = new Date(maxEndDate);
  const disabledStartForEndDate = values.startDate
    ? new Date(values.startDate)
    : disabledStartDate;

  return (
    <>
      <label htmlFor="startDate" className="text-sm">
        Start Date/Time
      </label>

      <DateTimePickerField
        name="startDate"
        disabledBefore={disabledStartDate}
        disabledAfter={disabledEndDate}
      />

      <div className="mt-4">
        <label htmlFor="endDate" className="text-sm">
          End Date/Time
        </label>
        <DateTimePickerField
          name="endDate"
          disabledBefore={disabledStartForEndDate}
          disabledAfter={disabledEndDate}
        />
      </div>
    </>
  );
};

DateTimeRangePicker.propTypes = {
  minStartDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date)
  ]),
  maxEndDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date)
  ])
};

export default DateTimeRangePicker;
